import { calculateDownPayment } from '@atc/wallet-payment-fns';

export default function calculateTotalPayment(monthlyPayment, paymentDetails, interestRate = 4.0) {
    const monthlyInterestRate = interestRate / 1200;
    const { tradeIn = {}, loanTerm = 60 } = paymentDetails;
    const { amountOwed = 0, value: tradeInValue = 0 } = tradeIn;

    const paymentNumerator = monthlyPayment * (((1 + monthlyInterestRate) ** loanTerm) - 1);
    const paymentDivisor = (monthlyInterestRate * ((1 + monthlyInterestRate) ** loanTerm));
    const loanAmountWithInterest = (paymentNumerator / paymentDivisor);
    const loanAmountNoInterest = monthlyPayment * loanTerm;

    const loanAmount = monthlyInterestRate > 0 ? loanAmountWithInterest : loanAmountNoInterest;
    const totalEquity = tradeInValue - amountOwed;
    const loanAmountWithEquity = loanAmount + totalEquity;

    const downPayment = calculateDownPayment(loanAmountWithEquity, paymentDetails, false);

    const price = loanAmountWithEquity + downPayment;

    return Math.ceil(price);
}
